/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import { CSSProperties, ReactElement } from 'react';
import { Loader, NotFoundComponent } from '..';
import classes from './style.module.scss';

type Theader = {
  key: string;
  name: string;
  style?: CSSProperties;
  render?: (v: any, obj?: any) => string | number | ReactElement;
};

interface ItableProps {
  thead: Theader[];
  theadStyle?: CSSProperties;
  bodyHeight?: number;
  tbody: Array<any>;
  name?: string;
  loading?: boolean;
}

const Table = ({
  thead,
  tbody,
  theadStyle = {},
  name = '',
  bodyHeight = 700,
  loading,
}: ItableProps) => {
  return (
    <div className={classes.table}>
      <div className={classes.thead} style={theadStyle}>
        {thead.map((head) => (
          <span key={`thead_${head.key}`} style={head.style ? head.style : {}}>
            {head.name}
          </span>
        ))}
      </div>
      <div className={classes.tbody}>
        <div
          className={classes.tbodyWrp}
          style={{
            height: tbody.length > 8 ? `${bodyHeight - 50}px` : 'auto',
          }}
          data-ispresent={!loading && tbody.length > 0}
        >
          {(() => {
            if (loading) {
              return (
                <div style={{ height: bodyHeight, position: 'relative' }}>
                  <Loader />
                </div>
              );
            }

            if (tbody.length > 0) {
              return (
                <>
                  {tbody.map((tr, i) => (
                    <div key={`${name}_${i}`} className={classes.tblRow}>
                      {thead.map((head) => (
                        <div
                          key={`tr_${head.key}`}
                          style={head.style ? head.style : {}}
                          className="fadeIn"
                        >
                          {head.render
                            ? head.render(tr[head.key], tr)
                            : tr[head.key]}
                        </div>
                      ))}
                    </div>
                  ))}
                </>
              );
            }

            if (!loading && tbody.length <= 0) {
              return (
                <div className={classes.notFoundCnt}>
                  <NotFoundComponent height={bodyHeight} />
                </div>
              );
            }

            return null;
          })()}
        </div>
      </div>
    </div>
  );
};
export default Table;
